/**
 * Evidence Pro Modal Atoms
 *
 * Atoms for controlling Evidence Pro specific modals.
 * These are separate from the general Heidi Pro modals.
 */

import { atom } from 'jotai';

/** Controls the "Using Evidence" disclaimer modal shown when opening /scribe/chat */
export const evidenceDisclaimerModalOpenAtom = atom(false);
